var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 12.75C17.25 13.2 16.95 13.5 16.5 13.5H1.5C1.05 13.5 0.75 13.2 0.75 12.75C0.75 12.3 1.05 12 1.5 12C2.325 12 3 11.325 3 10.5V6.75C3 3.45 5.7 0.75 9 0.75C12.3 0.75 15 3.45 15 6.75V10.5C15 11.325 15.675 12 16.5 12C16.95 12 17.25 12.3 17.25 12.75ZM10.95 16.125C10.5 16.875 9.75 17.25 9 17.25C8.625 17.25 8.25 17.175 7.875 16.95C7.5 16.725 7.275 16.5 7.05 16.125C6.825 15.75 6.975 15.3 7.35 15.075C7.725 14.85 8.175 15 8.4 15.375C8.42271 15.3977 8.44542 15.4273 8.47021 15.4596C8.52729 15.534 8.59542 15.6227 8.7 15.675C9.075 15.9 9.525 15.75 9.75 15.375C9.975 15 10.425 14.925 10.8 15.075C11.175 15.225 11.175 15.75 10.95 16.125ZM13.5 10.5C13.5 11.025 13.65 11.55 13.875 12H4.125C4.35 11.55 4.5 11.025 4.5 10.5V6.75C4.5 4.275 6.525 2.25 9 2.25C11.475 2.25 13.5 4.275 13.5 6.75V10.5Z",
    fill: "#6E6B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.2004da09c43abc2a87601d32b4f82e07.svg";
export { ForwardRef as ReactComponent };